const US_STATE_MAP: Record<string, string> = {
  Alabama: "us-al",
  Alaska: "us-ak",
  Arizona: "us-az",
  Arkansas: "us-ar",
  California: "us-ca",
  Colorado: "us-co",
  Connecticut: "us-ct",
  Delaware: "us-de",
  Florida: "us-fl",
  Georgia: "us-ga",
  Hawaii: "us-hi",
  Idaho: "us-id",
  Illinois: "us-il",
  Indiana: "us-in",
  Iowa: "us-ia",
  Kansas: "us-ks",
  Kentucky: "us-ky",
  Louisiana: "us-la",
  Maine: "us-me",
  Maryland: "us-md",
  Massachusetts: "us-ma",
  Michigan: "us-mi",
  Minnesota: "us-mn",
  Mississippi: "us-ms",
  Missouri: "us-mo",
  Montana: "us-mt",
  Nebraska: "us-ne",
  Nevada: "us-nv",
  "New Hampshire": "us-nh",
  "New Jersey": "us-nj",
  "New Mexico": "us-nm",
  "New York": "us-ny",
  "North Carolina": "us-nc",
  "North Dakota": "us-nd",
  Ohio: "us-oh",
  Oklahoma: "us-ok",
  Oregon: "us-or",
  Pennsylvania: "us-pa",
  "Rhode Island": "us-ri",
  "South Carolina": "us-sc",
  "South Dakota": "us-sd",
  Tennessee: "us-tn",
  Texas: "us-tx",
  Utah: "us-ut",
  Vermont: "us-vt",
  Virginia: "us-va",
  Washington: "us-wa",
  "West Virginia": "us-wv",
  Wisconsin: "us-wi",
  Wyoming: "us-wy",
  "District of Columbia": "us-dc",
};

export function mapRegion(country: string, region: string): string | null {
  if (country === "United States") {
    return US_STATE_MAP[region] ?? null;
  }
  return null;
}
